import { gsap } from 'gsap';

import formatBytes from './helpers/formatBytes';

const handleForm = () => {
  const formSelector = '.contact-modal';
  const overlaySelector = '.form-overlay';
  const closeBtnSelector = '.close-form-btn';
  const removeBtnSelector = '.remove-btn';
  const contentOuterSelector = '.form__content--outer';
  const contentInnerSelector = '.form__content--inner';
  const fileLabelSelector = '.form__label-text--file > .form__label-subtext';
  const headerSelector = '.header';

  const parentClassToggle = 'filled';
  const fileParentClassToggle = 'upload';
  const scrollClassToggle = 'scroll';

  const formEl = document.querySelector(formSelector);
  const overlayEl = document.querySelector(overlaySelector);
  const contentOuter = document.querySelector(contentOuterSelector);
  const contentInner = document.querySelector(contentInnerSelector);
  const closeBtnEl = document.querySelector(closeBtnSelector);
  const headerEl = document.querySelector(headerSelector);
  const body = document.body;

  const hidingEls = [overlayEl, closeBtnEl];

  const anchors = document.querySelectorAll('a[href="#modal"]');
  const inputsEl = formEl?.querySelectorAll(
    'input[type="text"], input[type="email"], input[type="tel"]'
  );
  const fileInputsEl = formEl?.querySelectorAll('input[type="file"]');

  let openModalTL = null;
  let closeModalTL = null;

  const openModalInit = () => {
    openModalTL = gsap.timeline({
      defaults: { duration: 0.4 },
    });

    openModalTL
      .to(formEl, {
        pointerEvents: 'all',
        duration: 0.01,
        onStart: () => {
          body.classList.toggle(scrollClassToggle);
          headerEl?.classList.toggle(scrollClassToggle);
        },
      })
      .to(overlayEl, { opacity: 1 }, '<')
      .to(contentOuter, { x: 0, ease: 'power4.out', duration: 0.8 }, '<+=0.1')
      .fromTo(
        contentInner,
        { x: '100%', autoAlpha: 0 },
        { x: 0, ease: 'power4.out', autoAlpha: 1, duration: 0.8 },
        '<'
      );

    return openModalTL;
  };

  const closeModalInit = () => {
    closeModalTL = gsap.timeline({
      defaults: { duration: 0.4 },
    });

    closeModalTL
      .to(formEl, {
        pointerEvents: 'none',
        duration: 0.01,
      })
      .to(overlayEl, { opacity: 0 }, '<')
      .to(
        contentOuter,
        { x: '100%', ease: 'power3.out', duration: 0.6 },
        '<+=0.1'
      )
      .to(
        contentInner,
        {
          autoAlpha: 0,
          ease: 'power3.out',
          duration: 0.6,
          onStart: () => {
            body.classList.toggle(scrollClassToggle);
            headerEl?.classList.toggle(scrollClassToggle);
          },
        },
        '<+=0.02'
      );

    return closeModalTL;
  };

  const openModal = (e) => {
    e.preventDefault();
    openModalTL !== null ? openModalTL.restart() : openModalInit();
  };

  const hideModal = () => {
    closeModalTL !== null ? closeModalTL.restart() : closeModalInit();
  };

  anchors?.forEach((anchor) => {
    anchor.addEventListener('click', openModal);
  });

  hidingEls.forEach((el) => {
    el?.addEventListener('click', hideModal);
  });

  inputsEl?.forEach((input) => {
    input.addEventListener('change', (e) => {
      const value = e?.target.value;
      const parent = e?.target.parentElement;

      if (value !== '') {
        parent?.classList.add(parentClassToggle);
        return;
      }

      parent?.classList.remove(parentClassToggle);
    });
  });

  const listenerAdded = [];

  fileInputsEl?.forEach((input, index) => {
    input.addEventListener('change', (event) => {
      const target = event.target;
      const [file] = target?.files;

      const filename = file?.name;
      const fileSize = file?.size ? formatBytes(file?.size) : undefined;

      const parentElement = target?.parentElement;
      const labelParent = parentElement?.parentElement;
      const groupParent = labelParent?.parentElement;

      const labelEl = labelParent?.querySelector(fileLabelSelector);
      const removeBtn = groupParent?.querySelector(removeBtnSelector);

      const labelContent =
        filename !== undefined
          ? `${filename} (${fileSize})`
          : 'Dołącz swoje CV*';

      if (labelEl !== null) {
        labelEl.textContent = labelContent;
      }

      if (listenerAdded[index] !== true) {
        removeBtn?.addEventListener('click', (e) => {
          e.preventDefault();
          target.value = '';
          target.dispatchEvent(event);
        });

        listenerAdded.push(true);
      }

      file !== undefined
        ? groupParent?.classList.add(fileParentClassToggle)
        : groupParent?.classList.remove(fileParentClassToggle);
    });
  });
};

export default handleForm;
